import { hot } from 'react-hot-loader/root'

import React from 'react'

import { BrowserRouter } from 'react-router-dom'
import { MetronomeProvider } from '@ally/metronome-ui'
import { DevicePrint } from '@ally/transmitigator'
import { AriaLiveProvider } from '@ally/use-aria-live'

import { GlobalLayout } from './layout'
import { track } from './tracking'

import {
  Warpgate,
  ScrollToTop,
  ErrorBoundary,
  SessionTimeout,
  LivePerson,
  RemoveHash,
  CPRAPreference,
} from './components'

import {
  SessionProvider,
  HostDataProvider,
  AnalyticsProvider,
  BootstrapProvider,
  TransmitRefProvider,
} from './providers'
import { FederatedApp } from './federation'
import { useAppFocus } from './hooks/focus'
import { ServicesProvider } from './services/ServicesProvider'

export const App: React.FC = () => {
  useAppFocus()

  return (
    <RemoveHash>
      <BrowserRouter>
        <MetronomeProvider>
          <AriaLiveProvider>
            <TransmitRefProvider>
              <DevicePrint track={track} />
              <SessionProvider>
                <Warpgate>
                  <BootstrapProvider>
                    <ServicesProvider>
                      <CPRAPreference />
                      <HostDataProvider>
                        <LivePerson />
                        <AnalyticsProvider>
                          <GlobalLayout>
                            <ErrorBoundary>
                              <FederatedApp />
                            </ErrorBoundary>
                          </GlobalLayout>
                          <ScrollToTop />
                          <SessionTimeout />
                        </AnalyticsProvider>
                      </HostDataProvider>
                    </ServicesProvider>
                  </BootstrapProvider>
                </Warpgate>
              </SessionProvider>
            </TransmitRefProvider>
          </AriaLiveProvider>
        </MetronomeProvider>
      </BrowserRouter>
    </RemoveHash>
  )
}

App.displayName = 'HostApp(ally-online-services)'
export default process.env.NODE_ENV === 'development' ? hot(App) : App
